import { NavLink, Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const location = useLocation();

    useEffect(() => { setOpen(false); }, [location.pathname]);

    const navItem = ({ isActive }) =>
        `text-[0.78rem] uppercase tracking-[0.22em] font-medium transition-colors ${
            isActive ? "text-[#1A1817]" : "text-[#5C5853] hover:text-[#1A1817]"
        }`;

    return (
        <header
            data-testid="site-navbar"
            className="sticky top-0 z-50 backdrop-blur-xl bg-[#F9F8F6]/85 border-b border-[#E5DED5]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="navbar-logo"
                    className="font-serif text-2xl md:text-[1.6rem] font-medium tracking-tight leading-none"
                >
                    Will Maxwell
                    <span className="block text-[0.6rem] tracking-[0.32em] uppercase text-[#5C5853] font-sans mt-1">
                        Photography
                    </span>
                </Link>

                <nav className="hidden md:flex items-center gap-10">
                    <NavLink to="/" end className={navItem} data-testid="nav-home">Services</NavLink>
                    <NavLink to="/portfolio" className={navItem} data-testid="nav-portfolio">Portfolio</NavLink>
                    <NavLink to="/contact" className={navItem} data-testid="nav-contact">Contact</NavLink>
                </nav>

                <Link
                    to="/contact"
                    data-testid="navbar-book-cta"
                    className="hidden md:inline-flex btn-editorial primary"
                >
                    Book Me
                </Link>

                <button
                    data-testid="navbar-mobile-toggle"
                    className="md:hidden text-[#1A1817] text-sm uppercase tracking-[0.2em]"
                    onClick={() => setOpen(!open)}
                >
                    {open ? "Close" : "Menu"}
                </button>
            </div>

            {open && (
                <div className="md:hidden border-t border-[#E5DED5] bg-[#F9F8F6]">
                    <div className="px-6 py-6 flex flex-col gap-5">
                        <NavLink to="/" end className={navItem} data-testid="mobile-nav-home">Services</NavLink>
                        <NavLink to="/portfolio" className={navItem} data-testid="mobile-nav-portfolio">Portfolio</NavLink>
                        <NavLink to="/contact" className={navItem} data-testid="mobile-nav-contact">Contact</NavLink>
                        <Link to="/contact" data-testid="mobile-book-cta" className="btn-editorial primary self-start">Book Me</Link>
                    </div>
                </div>
            )}
        </header>
    );
}
